'use es6';

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import PublicActivityMiddleware from '../middleware/PublicActivityMiddleware';
import ViewerCacheMiddleware from '../middleware/ViewerCacheMiddleware';
import * as ActionTypes from 'documents-lib/js/constants/ActionTypes';
import { errorMiddleware } from 'documents-lib/js/middleware/errorMiddleware';
export default function configureStore(initialState) {
  const createStoreWithMiddleware = compose(applyMiddleware(thunk, PublicActivityMiddleware(state => state.view.presentation, {
    identify: ActionTypes.VIEWER_IDENTIFIED,
    viewPage: ActionTypes.VIEW_PDF_PAGE,
    finish: ActionTypes.VIEWER_FINISHED
  }), ViewerCacheMiddleware(ActionTypes.VIEWER_IDENTIFIED), errorMiddleware), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f)(createStore);
  return createStoreWithMiddleware(rootReducer, initialState);
}